import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { isEmpty } from 'lodash-es';

import { ChangeOmaUserDetailsRequest, ChangeUserDetailsRequest } from '@vi-iot/client';

import { PATTERN } from '@common';
import { ContactDetailsFormGroup } from './contact-details.helper';
import { MatTooltip } from '@angular/material/tooltip';
import { matTooltipSetter } from 'src/app/shared/functions/mat-tooltip-setter/mat-tooltip-setter';

@Component({
  selector: 'app-contact-details',
  templateUrl: './contact-details.component.html',
  styleUrls: ['./contact-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactDetailsComponent implements OnInit {
  @ViewChildren(MatTooltip)
  set matTooltip(queryList: QueryList<MatTooltip>) {
    matTooltipSetter(queryList);
  }

  formGroup: FormGroup<ContactDetailsFormGroup>;

  @Input() details: {
    phoneNumber: string;
    mobileNumber: string;
  };
  @Input() isOmaUser: boolean;

  @Output() cancel: EventEmitter<void> = new EventEmitter<void>();

  @Output() save: EventEmitter<ChangeUserDetailsRequest> = new EventEmitter<
    ChangeUserDetailsRequest
  >();

  @Output() omaSave: EventEmitter<ChangeOmaUserDetailsRequest> = new EventEmitter<
    ChangeOmaUserDetailsRequest
  >();

  ngOnInit(): void {
    this.formGroup = new FormGroup<ContactDetailsFormGroup>({
      telephone: new FormControl<string>(
        { value: this.details.phoneNumber, disabled: this.isOmaUser },
        [Validators.pattern(PATTERN.PHONE), Validators.minLength(9)]
      ),
      mobile: new FormControl<string>(this.details.mobileNumber, [
        Validators.pattern(PATTERN.PHONE),
        Validators.minLength(9),
      ]),
    });
  }

  onCancel(): void {
    this.cancel.emit();
  }

  dispatchSave(): void {
    if (this.isOmaUser) {
      this.onOmaSave();
    } else {
      this.onSave();
    }
  }

  onSave(): void {
    const value = this.formGroup.value;
    const payload: ChangeUserDetailsRequest = {
      contacts: {
        telephone: value.telephone?.trim(),
        mobile: value.mobile?.trim(),
      },
    };

    if (isEmpty(payload)) {
      this.onCancel();
    } else {
      this.save.emit(payload);
    }
  }

  onOmaSave(): void {
    const value = this.formGroup.value;
    const payload: ChangeOmaUserDetailsRequest = {
      contacts: {
        mobile: value.mobile?.trim(),
      },
    };

    if (isEmpty(payload)) {
      this.onCancel();
    } else {
      this.omaSave.emit(payload);
    }
  }
}
